import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "./../components/Navbar/Navbar";
import { links } from "../components/Navbar/Mylinks";
import { Link, useNavigate } from "react-router-dom";
import HomeLayout from "../components/HomeLayout";
import axios from "axios";
import { IMG_SERVER_URL } from "../utils/constant";
import Loader from "../components/Loader";
import HomeBannerLayout from "../components/HomeBannerLayout";
import homeBannerImages from "../assets/homeBanner";
import ImgOptimized from "../components/ImgOptimized";
import { getUpdatedImageUrlWithSize } from "../utils/helpers";

const Home = () => {
  const [bg, setBg] = useState("");
  const [isBannerLoaded, setIsBannerLoaded] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/image/random-img`,
      );
      console.log(response);

      // setBg(`http://localhost:4000/brick-img${response.data.randomImg}.jpg`);
      setBg(`${IMG_SERVER_URL}/brick-img${response.data.randomImg}.jpg`);
      setIsFetching(false);
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setIsFetching(false);
    }
  };
  async function handleBannerLoad() {
    console.log("LOADED");

    setIsBannerLoaded(true);
  }

  useEffect(() => {
    // fetchProjects();
    const randomIndex = Math.floor(Math.random() * homeBannerImages.length);
    console.log(randomIndex);
    setBg(homeBannerImages[randomIndex]);
  }, []);

  console.log(isFetching, isBannerLoaded, bg);
  if (isFetching || (!isBannerLoaded && bg)) {
    return (
      <Loader>
        {/* pre loading image */}
        <ImgOptimized
          onLoad={handleBannerLoad}
          src={bg}
          className="absolute h-[60vh] lg:h-[80vh] w-full object-cover opacity-0"
        />
      </Loader>
    );
  }

  return (
    <>
      {/* <Loader className= {`${ (!isBannerLoaded) ? "opacity-100" : "opacity-5"}`}/> */}
      <HomeLayout>
        <div
          style={{
            background: `linear-gradient(45deg, 
                rgba(0,0,0, 0.2), 
                rgba(0,0,0, 0.2))`,
          }}
          className="h-[60vh] lg:h-[80vh] flex justify-center items-center relative"
        >
          <ImgOptimized
            onLoad={handleBannerLoad}
            src={bg}
            className="absolute h-[60vh] lg:h-[80vh] w-full object-cover"
          />
          <h1 className="container px-3 lg:px-10 text-5xl lg:text-8xl font-bold text-center text-[#fafafa] z-[5]">
            Welcome to AirBrick Design Library
          </h1>
          {/* <HomeBannerLayout /> */}
        </div>
        <Navbar />
        <div className="w-full p-3 mb-20">
          {/* Section 1 card */}
          <div className="mt-10">
            <h1 className="text-3xl text-center font-semibold mb-5">
              Best of Workspace Templates
            </h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {/* Card 1 */}
              <Link to="/showcase?tags=open-office">
                <div className="relative overflow-hidden bg-white rounded-2xl shadow-md">
                  <ImgOptimized
                    src={getUpdatedImageUrlWithSize(
                      `${IMG_SERVER_URL}/brick-img/41662.jpg`,
                      [1, 1, 2],
                    )}
                    alt="Image 1"
                    className="w-full h-[250px] object-cover"
                  />
                  <div className="absolute inset-0 flex items-end justify-start p-10 bg-black bg-opacity-25 hover:bg-opacity-40 text-white transition-opacity opacity-100">
                    <div className="text-left">
                      <h2 className="text-4xl mb-4 font-bold">Open Offices</h2>
                    </div>
                  </div>
                </div>
              </Link>
              {/* Card 2 */}
              <Link to="/showcase?tags=private-office">
                <div className="relative overflow-hidden bg-white rounded-2xl shadow-md">
                  <ImgOptimized
                    src={getUpdatedImageUrlWithSize(
                      `${IMG_SERVER_URL}/brick-img/414923.jpg`,
                      [1, 1, 2],
                    )}
                    alt="Image 1"
                    className="w-full h-[250px] object-cover"
                  />
                  <div className="absolute inset-0 flex items-end justify-start p-10 bg-black bg-opacity-25 hover:bg-opacity-40 text-white transition-opacity opacity-100">
                    <div className="text-left">
                      <h2 className="text-4xl mb-4 font-bold">
                        Private Cabins
                      </h2>
                    </div>
                  </div>
                </div>
              </Link>
              {/* Card 3 */}
              <Link to="/showcase?tags=work-lounge">
                <div className="relative overflow-hidden bg-white rounded-2xl shadow-md">
                  <ImgOptimized
                    src={getUpdatedImageUrlWithSize(
                      `${IMG_SERVER_URL}/brick-img/415928.jpg`,
                      [1, 1, 2],
                    )}
                    alt="Image 1"
                    className="w-full h-[250px] object-cover"
                  />
                  <div className="absolute inset-0 flex items-end justify-start p-10 bg-black bg-opacity-25 hover:bg-opacity-40 text-white transition-opacity opacity-100">
                    <div className="text-left">
                      <h2 className="text-4xl mb-4 font-bold">Work Lounges</h2>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          {/* Section 2 card */}
          <div>
            {links
              .filter(
                (link) =>
                  link.name === "Meeting Spaces" ||
                  link.name === "Support Spaces",
              )
              .map((link, index) => (
                <div key={index} className="mt-20">
                  <h1 className="text-3xl text-center font-semibold mb-5">
                    Best of {link.name} Templates
                  </h1>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {link.sublink.map((sublink, subIndex) => (
                      <Link
                        key={subIndex}
                        to={`${
                          process.env.REACT_APP_FRONT_URL
                        }/showcase?tags=${sublink.name
                          .toLowerCase()
                          .replace(/\s+/g, "-")
                          .replace(/\//g, "-")}`}
                      >
                        <div className="relative overflow-hidden bg-white rounded-2xl shadow-md cursor-pointer">
                          <ImgOptimized
                            src={getUpdatedImageUrlWithSize(
                              `${IMG_SERVER_URL}/brick-img${sublink?.imgLink}.jpg`,
                              [1, 1, 2],
                            )}
                            alt="Image 1"
                            className="w-full h-[120px] object-cover"
                          />
                          <div className="absolute inset-0 flex items-center justify-center p-10 bg-black bg-opacity-25 hover:bg-opacity-40 text-white transition-opacity opacity-100">
                            <div className="text-left">
                              <h2 className="text-lg font-bold">
                                {sublink.name}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </HomeLayout>
    </>
  );
};

export default Home;
